/**
 * 서버의 default-config-system-options.json 시스템 설정 기본값
 */
export const CONFIG_SYSTEM_DEFAULTS = {
    // 시스템 기본 설정
    SYSTEM_UNLIMIT_ID: "intosoft",
    SYSTEM_ADMIN_ID: "admin",
    SYSTEM_RESOURCE_PATH: "",
    SYSTEM_INTO_CONVERTER_PATH: "",

    // 업로드 설정
    SYSTEM_FILE_UPLOAD_SIZE: 30,
    SYSTEM_CHECK_MAGIC_NUMBER_ENABLE: false,

    // 스케쥴러 설정
    SYSTEM_SCHEDULE_VIEWER_EXPIRE_ENABLE: true,
    SYSTEM_SCHEDULE_VIEWER_DELETE_ENABLE: true,
    SYSTEM_SCHEDULE_VIEWER_REMOVE_ENABLE: true,
    SYSTEM_SCHEDULE_VIEWER_EXPIRE_DAYS: 1,
    SYSTEM_SCHEDULE_VIEWER_DELETE_DAYS: 1,
    SYSTEM_SCHEDULE_VIEWER_REMOVE_DAYS: 1,

    // 통합뷰어 모듈 설정 (TM = Task Module)
    TM_ENABLE: false,
    TM_JAVA_PATH: "",
    TM_CONVERT_ASYNC_ENABLE: false,

    // ZIP 변환 설정
    TM_CONVERT_ZIP_ENABLE: true,

    // 이미지 변환 설정
    TM_CONVERT_IMAGE_ENABLE: true,
    TM_CONVERT_IMAGE_FORMATS: "png|jpg|jpeg|tiff|svg|gif|bmp",

    // POLARIS 변환 설정
    TM_CONVERT_PO_ENABLE: false,
    TM_CONVERT_PO_PATH: "",
    TM_CONVERT_PO_FORMATS: "doc|docx|xls|xlsx|ppt|pptx|hwp|hwpx|odt",

    // 타임스탬프 설정
    TM_TIMESTAMP_ENABLE: false,
    TM_TIMESTAMP_TYPE: "GTSA",

    // 아마노 타임스탬프 설정
    TM_TIMESTAMP_AMN_ENABLE: false,
    TM_TIMESTAMP_AMN_OUT_FLAG_ENABLE: false,
    TM_TIMESTAMP_AMN_LICENSE_PATH: "",
    TM_TIMESTAMP_AMN_POSITION_DEFAULT_X: 50,
    TM_TIMESTAMP_AMN_POSITION_DEFAULT_Y: 50,
    TM_TIMESTAMP_AMN_POSITION_DEFAULT_PAGE: 1,

    // 드림시큐리티 타임스탬프 설정
    TM_TIMESTAMP_DRM_ENABLE: false,
    TM_TIMESTAMP_DRM_LDAP_ENABLE: false,
    TM_TIMESTAMP_DRM_CONFIG_PATH: "",
    TM_TIMESTAMP_DRM_POSITION_DEFAULT_X: 50,
    TM_TIMESTAMP_DRM_POSITION_DEFAULT_Y: 50,
    TM_TIMESTAMP_DRM_POSITION_DEFAULT_PAGE: 1,

    // 다중뷰어 & DMV 설정
    TM_MULTI_DOCUMENT_ENABLE: true,
    TM_MULTI_DOCUMENT_DMV_ENABLE: false,

    // Ebook & TTS & 고대비 설정
    TM_EBOOK_ENABLE: false,
    TM_TTS_ENABLE: false,
    TM_HIGH_CONTRAST_ENABLE: false,

    // 인쇄 모듈 설정
    TM_PRINT_CLIENT_ENABLE: false,

    // 열람통제 설정
    TM_VIEW_LIMIT_ENABLE: false,
    TM_VIEW_LIMIT_VALID_DAYS_ENABLE: true,
    TM_VIEW_LIMIT_HIT_COUNT_ENABLE: true,
    TM_VIEW_LIMIT_DOWNLOAD_COUNT_ENABLE: true,
    TM_VIEW_LIMIT_PRINT_COUNT_ENABLE: true,
    TM_VIEW_LIMIT_VALID_DAYS: 100,
    TM_VIEW_LIMIT_HIT_COUNT: 100,
    TM_VIEW_LIMIT_DOWNLOAD_COUNT: 100,
    TM_VIEW_LIMIT_PRINT_COUNT: 100,
};

/**
 * 시스템 설정 키 정의
 * 서버로부터 받아올 설정 키 목록
 */
export const CONFIG_SYSTEM_KEYS = [
    // 시스템 기본 설정
    "SYSTEM_UNLIMIT_ID",
    "SYSTEM_ADMIN_ID",
    "SYSTEM_RESOURCE_PATH",
    "SYSTEM_INTO_CONVERTER_PATH",

    // 업로드 설정
    "SYSTEM_FILE_UPLOAD_SIZE",
    "SYSTEM_CHECK_MAGIC_NUMBER_ENABLE",

    // 스케쥴러 설정
    "SYSTEM_SCHEDULE_VIEWER_EXPIRE_ENABLE",
    "SYSTEM_SCHEDULE_VIEWER_DELETE_ENABLE",
    "SYSTEM_SCHEDULE_VIEWER_REMOVE_ENABLE",
    "SYSTEM_SCHEDULE_VIEWER_EXPIRE_DAYS",
    "SYSTEM_SCHEDULE_VIEWER_DELETE_DAYS",
    "SYSTEM_SCHEDULE_VIEWER_REMOVE_DAYS",

    // 통합뷰어 모듈 설정 (TM = Task Module)
    "TM_ENABLE",
    "TM_JAVA_PATH",
    "TM_CONVERT_ASYNC_ENABLE",

    // ZIP 변환 설정
    "TM_CONVERT_ZIP_ENABLE",

    // 이미지 변환 설정
    "TM_CONVERT_IMAGE_ENABLE",
    "TM_CONVERT_IMAGE_FORMATS",

    // POLARIS 변환 설정
    "TM_CONVERT_PO_ENABLE",
    "TM_CONVERT_PO_PATH",
    "TM_CONVERT_PO_FORMATS",

    // 타임스탬프 설정
    "TM_TIMESTAMP_ENABLE",
    "TM_TIMESTAMP_TYPE",

    // 아마노 타임스탬프 설정
    "TM_TIMESTAMP_AMN_ENABLE",
    "TM_TIMESTAMP_AMN_OUT_FLAG_ENABLE",
    "TM_TIMESTAMP_AMN_LICENSE_PATH",
    "TM_TIMESTAMP_AMN_POSITION_DEFAULT_X",
    "TM_TIMESTAMP_AMN_POSITION_DEFAULT_Y",
    "TM_TIMESTAMP_AMN_POSITION_DEFAULT_PAGE",

    // 드림시큐리티 타임스탬프 설정
    "TM_TIMESTAMP_DRM_ENABLE",
    "TM_TIMESTAMP_DRM_LDAP_ENABLE",
    "TM_TIMESTAMP_DRM_CONFIG_PATH",
    "TM_TIMESTAMP_DRM_POSITION_DEFAULT_X",
    "TM_TIMESTAMP_DRM_POSITION_DEFAULT_Y",
    "TM_TIMESTAMP_DRM_POSITION_DEFAULT_PAGE",

    // 다중뷰어 & DMV 설정
    "TM_MULTI_DOCUMENT_ENABLE",
    "TM_MULTI_DOCUMENT_DMV_ENABLE",

    // Ebook & TTS & 고대비 설정
    "TM_EBOOK_ENABLE",
    "TM_TTS_ENABLE",
    "TM_HIGH_CONTRAST_ENABLE",

    // 인쇄 모듈 설정
    "TM_PRINT_CLIENT_ENABLE",

    // 열람통제 설정
    "TM_VIEW_LIMIT_ENABLE",
    "TM_VIEW_LIMIT_VALID_DAYS_ENABLE",
    "TM_VIEW_LIMIT_HIT_COUNT_ENABLE",
    "TM_VIEW_LIMIT_DOWNLOAD_COUNT_ENABLE",
    "TM_VIEW_LIMIT_PRINT_COUNT_ENABLE",
    "TM_VIEW_LIMIT_VALID_DAYS",
    "TM_VIEW_LIMIT_HIT_COUNT",
    "TM_VIEW_LIMIT_DOWNLOAD_COUNT",
    "TM_VIEW_LIMIT_PRINT_COUNT"
];

/**
 * 숫자로 변환해야 하는 설정 키 목록
 */
export const CONFIG_SYSTEM_NUMBER_KEYS = [
    "SYSTEM_FILE_UPLOAD_SIZE",
    "SYSTEM_SCHEDULE_VIEWER_EXPIRE_DAYS",
    "SYSTEM_SCHEDULE_VIEWER_DELETE_DAYS",
    "SYSTEM_SCHEDULE_VIEWER_REMOVE_DAYS",
    "TM_TIMESTAMP_AMN_POSITION_DEFAULT_X",
    "TM_TIMESTAMP_AMN_POSITION_DEFAULT_Y",
    "TM_TIMESTAMP_AMN_POSITION_DEFAULT_PAGE",
    "TM_TIMESTAMP_DRM_POSITION_DEFAULT_X",
    "TM_TIMESTAMP_DRM_POSITION_DEFAULT_Y",
    "TM_TIMESTAMP_DRM_POSITION_DEFAULT_PAGE",
    "TM_VIEW_LIMIT_VALID_DAYS",
    "TM_VIEW_LIMIT_HIT_COUNT",
    "TM_VIEW_LIMIT_DOWNLOAD_COUNT",
    "TM_VIEW_LIMIT_PRINT_COUNT",
];

/**
 * L10n 키 매핑
 * 각 시스템 설정 키에 대한 번역 키
 */
export const CONFIG_SYSTEM_L10N = {
    // 시스템 기본 설정
    "SYSTEM_UNLIMIT_ID": "configs.system.SYSTEM_UNLIMIT_ID",
    "SYSTEM_ADMIN_ID": "configs.system.SYSTEM_ADMIN_ID",
    "SYSTEM_RESOURCE_PATH": "configs.system.SYSTEM_RESOURCE_PATH",
    "SYSTEM_INTO_CONVERTER_PATH": "configs.system.SYSTEM_INTO_CONVERTER_PATH",
    "SYSTEM_FILE_UPLOAD_SIZE": "configs.system.SYSTEM_FILE_UPLOAD_SIZE",
    "SYSTEM_CHECK_MAGIC_NUMBER_ENABLE": "configs.system.SYSTEM_CHECK_MAGIC_NUMBER_ENABLE",

    // 스케쥴러 설정
    "SYSTEM_SCHEDULE_VIEWER_EXPIRE_ENABLE": "configs.system.SYSTEM_SCHEDULE_VIEWER_EXPIRE_ENABLE",
    "SYSTEM_SCHEDULE_VIEWER_DELETE_ENABLE": "configs.system.SYSTEM_SCHEDULE_VIEWER_DELETE_ENABLE",
    "SYSTEM_SCHEDULE_VIEWER_REMOVE_ENABLE": "configs.system.SYSTEM_SCHEDULE_VIEWER_REMOVE_ENABLE",
    "SYSTEM_SCHEDULE_VIEWER_EXPIRE_DAYS": "configs.system.SYSTEM_SCHEDULE_VIEWER_EXPIRE_DAYS",
    "SYSTEM_SCHEDULE_VIEWER_DELETE_DAYS": "configs.system.SYSTEM_SCHEDULE_VIEWER_DELETE_DAYS",
    "SYSTEM_SCHEDULE_VIEWER_REMOVE_DAYS": "configs.system.SYSTEM_SCHEDULE_VIEWER_REMOVE_DAYS",

    // 통합뷰어 모듈 설정 (TM = Task Module)
    "TM_ENABLE": "configs.system.TM_ENABLE",
    "TM_JAVA_PATH": "configs.system.TM_JAVA_PATH",
    "TM_CONVERT_ASYNC_ENABLE": "configs.system.TM_CONVERT_ASYNC_ENABLE",

    // ZIP 변환 설정
    "TM_CONVERT_ZIP_ENABLE": "configs.system.TM_CONVERT_ZIP_ENABLE",

    // 이미지 변환 설정
    "TM_CONVERT_IMAGE_ENABLE": "configs.system.TM_CONVERT_IMAGE_ENABLE",
    "TM_CONVERT_IMAGE_FORMATS": "configs.system.TM_CONVERT_IMAGE_FORMATS",

    // POLARIS 변환 설정
    "TM_CONVERT_PO_ENABLE": "configs.system.TM_CONVERT_PO_ENABLE",
    "TM_CONVERT_PO_PATH": "configs.system.TM_CONVERT_PO_PATH",
    "TM_CONVERT_PO_FORMATS": "configs.system.TM_CONVERT_PO_FORMATS",

    // 타임스탬프 설정
    "TM_TIMESTAMP_ENABLE": "configs.system.TM_TIMESTAMP_ENABLE",
    "TM_TIMESTAMP_TYPE": "configs.system.TM_TIMESTAMP_TYPE",

    // 아마노 타임스탬프 설정
    "TM_TIMESTAMP_AMN_ENABLE": "configs.system.TM_TIMESTAMP_AMN_ENABLE",
    "TM_TIMESTAMP_AMN_OUT_FLAG_ENABLE": "configs.system.TM_TIMESTAMP_AMN_OUT_FLAG_ENABLE",
    "TM_TIMESTAMP_AMN_LICENSE_PATH": "configs.system.TM_TIMESTAMP_AMN_LICENSE_PATH",
    "TM_TIMESTAMP_AMN_POSITION_DEFAULT_X": "configs.system.TM_TIMESTAMP_AMN_POSITION_DEFAULT_X",
    "TM_TIMESTAMP_AMN_POSITION_DEFAULT_Y": "configs.system.TM_TIMESTAMP_AMN_POSITION_DEFAULT_Y",
    "TM_TIMESTAMP_AMN_POSITION_DEFAULT_PAGE": "configs.system.TM_TIMESTAMP_AMN_POSITION_DEFAULT_PAGE",

    // 드림시큐리티 타임스탬프 설정
    "TM_TIMESTAMP_DRM_ENABLE": "configs.system.TM_TIMESTAMP_DRM_ENABLE",
    "TM_TIMESTAMP_DRM_LDAP_ENABLE": "configs.system.TM_TIMESTAMP_DRM_LDAP_ENABLE",
    "TM_TIMESTAMP_DRM_CONFIG_PATH": "configs.system.TM_TIMESTAMP_DRM_CONFIG_PATH",
    "TM_TIMESTAMP_DRM_POSITION_DEFAULT_X": "configs.system.TM_TIMESTAMP_DRM_POSITION_DEFAULT_X",
    "TM_TIMESTAMP_DRM_POSITION_DEFAULT_Y": "configs.system.TM_TIMESTAMP_DRM_POSITION_DEFAULT_Y",
    "TM_TIMESTAMP_DRM_POSITION_DEFAULT_PAGE": "configs.system.TM_TIMESTAMP_DRM_POSITION_DEFAULT_PAGE",

    // 다중뷰어 & DMV 설정
    "TM_MULTI_DOCUMENT_ENABLE": "configs.system.TM_MULTI_DOCUMENT_ENABLE",
    "TM_MULTI_DOCUMENT_DMV_ENABLE": "configs.system.TM_MULTI_DOCUMENT_DMV_ENABLE",

    // Ebook & TTS & 고대비 설정
    "TM_EBOOK_ENABLE": "configs.system.TM_EBOOK_ENABLE",
    "TM_TTS_ENABLE": "configs.system.TM_TTS_ENABLE",
    "TM_HIGH_CONTRAST_ENABLE": "configs.system.TM_HIGH_CONTRAST_ENABLE",

    // 인쇄 모듈 설정
    "TM_PRINT_CLIENT_ENABLE": "configs.system.TM_PRINT_CLIENT_ENABLE",

    // 열람통제 설정
    "TM_VIEW_LIMIT_ENABLE": "configs.system.TM_VIEW_LIMIT_ENABLE",
    "TM_VIEW_LIMIT_VALID_DAYS_ENABLE": "configs.system.TM_VIEW_LIMIT_VALID_DAYS_ENABLE",
    "TM_VIEW_LIMIT_HIT_COUNT_ENABLE": "configs.system.TM_VIEW_LIMIT_HIT_COUNT_ENABLE",
    "TM_VIEW_LIMIT_DOWNLOAD_COUNT_ENABLE": "configs.system.TM_VIEW_LIMIT_DOWNLOAD_COUNT_ENABLE",
    "TM_VIEW_LIMIT_PRINT_COUNT_ENABLE": "configs.system.TM_VIEW_LIMIT_PRINT_COUNT_ENABLE",
    "TM_VIEW_LIMIT_VALID_DAYS": "configs.system.TM_VIEW_LIMIT_VALID_DAYS",
    "TM_VIEW_LIMIT_HIT_COUNT": "configs.system.TM_VIEW_LIMIT_HIT_COUNT",
    "TM_VIEW_LIMIT_DOWNLOAD_COUNT": "configs.system.TM_VIEW_LIMIT_DOWNLOAD_COUNT",
    "TM_VIEW_LIMIT_PRINT_COUNT": "configs.system.TM_VIEW_LIMIT_PRINT_COUNT",
};